/**
 * SeverityPill — colour-coded severity chip (WSRPDM-0011).
 *
 * Presentational: takes the raw severity string, resolves its label through
 * the registry (`severityLabel`, raw-enum fallback for anything unmapped),
 * and maps INFO/WARN/ERROR to their theme colours. An unmapped severity
 * still renders (neutral) rather than breaking.
 */
import { Chip } from '@mui/material';
import { useCopy } from '@/hooks/useCopy';
import { severityLabel } from '@/domain/registry';

type ChipColor = 'default' | 'info' | 'warning' | 'error';

const SEVERITY_COLOR: Record<string, ChipColor> = {
  INFO: 'info',
  WARN: 'warning',
  ERROR: 'error',
};

interface SeverityPillProps {
  severity: string;
}

export function SeverityPill({ severity }: SeverityPillProps) {
  const { t } = useCopy();
  const label = severityLabel(severity, t);
  const color = SEVERITY_COLOR[severity] ?? 'default';
  return <Chip label={label} color={color} size="small" />;
}
